// extracted by mini-css-extract-plugin
export default {"ErrorPage":"ErrorPage_ErrorPage__nTcta","IconBlank":"ErrorPage_IconBlank__kZCgl","Title":"ErrorPage_Title__iu+wo","SubTitle":"ErrorPage_SubTitle__wwlD0"};